import React from 'react';
import './Hero.css';

const Hero = ({
  title,
  subtitle,
  label,
  children,
  video,
  videoWebm,
  poster,
  image,
  overlay = true,
  size = 'large'
}) => {
  return (
    <section className={`hero hero-${size}`}>
      {video && (
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster={poster}
        >
          {videoWebm && <source src={videoWebm} type="video/webm" />}
          <source src={video} type="video/mp4" />
        </video>
      )}
      {image && !video && (
        <div
          className="hero-image"
          style={{ backgroundImage: `url(${image})` }}
        />
      )}
      {overlay && <div className="hero-overlay" />}

      <div className="hero-content">
        {label && <span className="hero-label">{label}</span>}
        <h1 className="hero-title">{title}</h1>
        {subtitle && <p className="hero-subtitle">{subtitle}</p>}
        {children && <div className="hero-actions">{children}</div>}
      </div>
    </section>
  );
};

export default Hero;
